module.exports = __webpack_public_path__ + "media/images/ucsf_channels_landing-e019f1fa0ad285c9e0ddfff1191fed5b.png";